<template>
  <div class="settings">
    <child-org-selection-panel
      :has-unsaved-changes="generalSettingsHasChanges"
      @selected-org-changed="onOrgChanged"
    />
    <v-alert
      v-if="showWarning"
      type="info"
    >
      {{
        onlyFutureRateConfigurations
          ? $t("backofficeStrings.futureConfigurationsOnlyWarning")
          : $t("backofficeStrings.inconsistentConfigurationWarning")
      }}
    </v-alert>
    <v-tabs
      v-model="activeTab"
      align-tabs="center"
      show-arrows
    >
      <v-tab value="generalTab">
        {{ $t("generalSettingsStrings.title") }}
      </v-tab>
      <v-tab value="rateSummariesTab">
        {{ $t("rateConfigurationSummariesStrings.title") }}
      </v-tab>
      <v-tab value="financialDimensionsTab">
        {{ $t("financialDimensionStrings.title") }}
      </v-tab>
    </v-tabs>
    <v-tabs-window v-model="activeTab">
      <v-tabs-window-item value="generalTab">
        <general-settings
          :selected-org-id="selectedOrgId"
          :selected-org-type-id="selectedOrgTypeId"
          @general-settings-loaded="generalSettingsLoaded = true"
          @has-changes-changed="onHasChangesChanged"
        />
      </v-tabs-window-item>
      <v-tabs-window-item value="rateSummariesTab">
        <rate-summaries
          :selected-org-id="selectedOrgId"
          @rate-summaries-loaded="rateSummariesLoaded = true"
        />
      </v-tabs-window-item>
      <v-tabs-window-item value="financialDimensionsTab">
        <!-- The v-if here causes tab content to be destroyed and mounted again when switching tabs -->
        <financial-dimension-settings
          v-if="activeTab === 'financialDimensionsTab'"
          :selected-org-id="selectedOrgId"
        />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
import ChildOrgSelectionPanel from "./components/ChildOrgSelectionPanel";
import RateSummaries from "./components/RateSummaries";
import GeneralSettings from "./components/GeneralSettings";
import FinancialDimensionSettings from "./components/FinancialDimensionSettings";
import { mapGetters } from "vuex";
import _ from "lodash";
import { m } from '@/plugins/moment';

export default {
  name: "SettingsPage",
  components: {
    ChildOrgSelectionPanel,
    GeneralSettings,
    RateSummaries,
    FinancialDimensionSettings
  },
  data() {
    return {
      activeTab: "generalTab",
      selectedOrgId: null,
      selectedOrgTypeId: null,
      generalSettingsLoaded: false,
      rateSummariesLoaded: false,
      generalSettingsHasChanges: false
    };
  },
  computed: {
    ...mapGetters({
      isActive: "settings/orgConfigurationStore/isActive",
      rateSummaries: "settings/rateSummariesStore/rateSummaries"
    }),
    onlyFutureRateConfigurations() {
      const today = m();

      if (!_.some(this.rateSummaries)) {
        return false;
      }

      return _.every(this.rateSummaries, x => today.isBefore(x.fromDate));
    },
    showWarning() {
      if (!this.generalSettingsLoaded || !this.rateSummariesLoaded) {
        return false;
      }

      //warning returned if general settings and rate configurations are not consistent
      if (
        !this.isActive ||
        !this.rateSummaries ||
        this.rateSummaries.length === 0
      ) {
        return true;
      }

      return this.onlyFutureRateConfigurations;
    }
  },
  methods: {
    onOrgChanged(org) {
      this.selectedOrgId = org?.id ?? null;
      this.selectedOrgTypeId = org?.orgTypeId ?? null;
    },
    onHasChangesChanged(val) {
      this.generalSettingsHasChanges = !!val;
    }
  }
};
</script>
